export default "__VITE_ASSET__DlcUNBrV__"